import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Address } from "@/interfaces";
import { formatCep } from "@/util/formatters";

interface AddressSelectorComponentProps {
  addresses: Address[];
  value?: Address;
  onSelect: (address: Address | null) => void;
}

const AddressSelectorComponent: React.FC<AddressSelectorComponentProps> = ({
  addresses,
  value,
  onSelect,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSelectAddress = (address: Address | null) => {
    onSelect(address);
    setIsModalOpen(false);
  };

  if (!value && addresses.length) {
    onSelect(addresses[0]);
  }

  return (
    <div>
      {value ? (
        <div className="mb-4 flex justify-start align-top">
          <div>
            <p className="font-semibold">
              {value.line1}, {value.number}
            </p>
            <p className="text-sm text-gray-600">
              {value.neighborhood}, {value.city}
              {value.zipCode ? `, ${formatCep(value.zipCode)}` : ""}
              {value.line2 && <span>, {value.line2}</span>}
            </p>
          </div>
          <Button
            variant="link"
            type="button"
            className="text-red-600"
            onClick={() => setIsModalOpen(true)}
          >
            Editar
          </Button>
        </div>
      ) : (
        <div>
          <h4 className="text-lg font-semibold">
            O cliente não possui endereços cadastrados
          </h4>
        </div>
      )}

      {/* Modal */}
      <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Selecione um endereço</DialogTitle>
          </DialogHeader>
          <ul className="space-y-4">
            {addresses.map((address) => (
              <li
                key={`${address.zipCode}-${address.line1}`}
                onClick={() => handleSelectAddress(address)}
                className="cursor-pointer border rounded-lg p-4 shadow-sm hover:shadow-md hover:border-gray-400 transition"
              >
                <div>
                  <p className="font-semibold">
                    {address.line1}, {address.number}
                  </p>
                  <p className="text-sm text-gray-600">
                    {address.neighborhood}, {address.city}
                    {address.zipCode ? `, ${formatCep(address.zipCode)}` : ""}
                    {address.line2 && <span>, {address.line2}</span>}
                  </p>
                </div>
              </li>
            ))}
          </ul>
          <DialogFooter>
            <Button variant="outline" onClick={() => setIsModalOpen(false)}>
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddressSelectorComponent;
